import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { linkStyles, pageStyles } from './components/cssstyles.js';
import { PageUserProjects } from './page-user-projects.js';
import { tasks } from './tasks.js';

export function pageNotFound() {
  return html`<page-http-error code=404></page-http-error>`;
}

function httpErrorText(code: string|undefined): { title: string, subtitle: string } {
  if (code === '402')
    return { title: 'Payment Required', subtitle: 'Please make sure the organization billing is up-to-date.' };
  if (code === '403')
    return { title: 'Forbidden', subtitle: '' };
  return { title: 'Not Found', subtitle: 'The URL may be incorrect, or the page no longer exists.' };
}

@customElement('page-http-error')
export class PageHTTPError extends LitElement {

  @property({}) code?: string;
  @property({}) text?: string;

  private _pageMetadataTask = tasks.pageMetadata(this, {
    args: () => [this.code] as const,
    metadata: ([code]) => ({ title: httpErrorText(code).title }),
  });

  override render() {
    const { title, subtitle } = httpErrorText(this.code);
    return html`
      <app-header></app-header>
      <app-body>
        <h-box class=title>
          <div class=code>${this.code}</div>
          <div>${title}</div>
        </h-box>
        <div class=header>${this.text ?? subtitle}</div>
        <h-box>
          <sl-button variant=primary href=${PageUserProjects.url()}>Go to dashboard</sl-button>
        </h-box>
      </app-body>
      <app-footer></app-footer>
    `
  }

  static styles = [linkStyles, pageStyles, css`
    
    app-body {
      margin-top: var(--sl-spacing-4x-large);

      .code {
        font-size: var(--sl-font-size-4x-large);
        color: var(--sl-color-neutral-400);
      }

      .dot {
        color: var(--sl-color-neutral-400);
      }

      .title {
        font-size: var(--sl-font-size-4x-large);
        gap: var(--sl-spacing-2x-large);
      }

      .header {
        font-size: var(--sl-font-size-x-large);
        color: var(--sl-color-neutral-400);
      }

      sl-button {
        margin-top: var(--sl-spacing-large);
      }
    }
  `];
}
